import React from 'react';
import styled from '@emotion/styled/macro';
import AppDownloadWidget from 'containers/AppDownloadWidget/AppDownloadWidget';
import AuthenticatedGreeting from 'containers/AuthenticatedGreeting';
import BirthdayAndJobAnniversaryWidget from 'containers/BirthdayAndJobAnniversaryWidget/BirthdayAndJobAnniversaryWidget';
import Boosts from 'containers/Boosts';
import CalendarWidget from 'containers/Calendar/CalendarWidget';
import ChipsWidget from 'containers/ChipsWidget/ChipsWidget';
import ActiveChallenges from 'containers/Challenge/ActiveChallenges';
import CollectionWidget from 'containers/Collections/CollectionWidget';
import DocumentWidget from 'containers/Documents/DocumentWidget';
import HomeFeed from 'containers/HomeFeed';
import NoticeWidget from 'containers/Notices/NoticeWidget';
import ActivePulseSurveyForm from 'containers/Pulse/ActivePulseSurveyForm';

// Without a card around them, these sections need extra room to stand apart from the widget above.
// The spacing is the grid item itself, so it hides when the section renders nothing and leaves no gap.
const SectionSpacing = styled.div`
  &::before {
    content: '';
    display: block;
    height: ${({ theme }) => theme.spacing(1)};
  }

  &:first-child::before,
  &:empty {
    display: none;
  }
`;

const HomeBoosts = ({ className, ...props }) => <SectionSpacing className={className}><Boosts {...props} /></SectionSpacing>;
const HomeActiveChallenges = ({ className, ...props }) => <SectionSpacing className={className}><ActiveChallenges {...props} /></SectionSpacing>;
const HomeCalendar = ({ className, ...props }) => <SectionSpacing className={className}><CalendarWidget {...props} /></SectionSpacing>;

// The home grid spaces the widgets, so the pulse needs none of its own
const HomePulse = props => <ActivePulseSurveyForm disablePadding {...props} />;

const widgetManager = {
  greeting: AuthenticatedGreeting,
  app_download: AppDownloadWidget,
  notice: NoticeWidget,
  boosts: HomeBoosts,
  active_challenges: HomeActiveChallenges,
  calendar: HomeCalendar,
  birthdays_and_job_anniversaries: BirthdayAndJobAnniversaryWidget,
  pulse: HomePulse,
  collection: CollectionWidget,
  chips: ChipsWidget,
  document: DocumentWidget,
  feed: HomeFeed,
};

// The greeting is a Grid container of its own, so it sits inside the item instead of being one
export const wrappedWidgets = ['greeting'];

export default widgetManager;
